// extracted by mini-css-extract-plugin
export default {"download-hub-button-wrapper":"downloadHubButton_download-hub-button-wrapper__uwt4e","new-indicate":"downloadHubButton_new-indicate__-FrdS"};